import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from "./Assets/Strings/En/translation.json";
import deTranslation from "./Assets/Strings/De/translation.json";
import frTranslation from "./Assets/Strings/Fr/translation.json";
import itTranslation from "./Assets/Strings/It/translation.json";
import esTranslation from "./Assets/Strings/Es/translation.json";
import jpTranslation from "./Assets/Strings/Jp/translation.json";
import krTranslation from "./Assets/Strings/Kr/translation.json";
import cnTranslation from "./Assets/Strings/Cn/translation.json";

import enMisc from "./Assets/Strings/En/misc.json";
import deMisc from "./Assets/Strings/De/misc.json";
import frMisc from "./Assets/Strings/Fr/misc.json";
import itMisc from "./Assets/Strings/It/misc.json";
import esMisc from "./Assets/Strings/Es/misc.json";
import jpMisc from "./Assets/Strings/Jp/misc.json";
import krMisc from "./Assets/Strings/Kr/misc.json";
import cnMisc from "./Assets/Strings/Cn/misc.json";

import LanguageDetector from 'i18next-browser-languagedetector';
// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: false,
    languages: ['de','en', "es", "jp", "kr", "cn", "it", "fr"],
    resources: {
      "en": {
        translation: enTranslation,
        misc: enMisc
      },
      "de": {
        translation: deTranslation,
        misc: deMisc
      },
      "es": {
        translation: esTranslation,
        misc: esMisc
      },
      "fr": {
        translation: frTranslation,
        misc: frMisc
      },
      "it": {
        translation: itTranslation,
        misc: itMisc
      },
      "kr": {
        translation: krTranslation,
        misc: krMisc
      },
      "cn": {
        translation: cnTranslation,
        misc: cnMisc
      },
      "jp": {
        translation: jpTranslation,
        misc: jpMisc
      }
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });


export default i18n;